module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-12.9a662b07.png";